import type { LigneFiche } from '../../lib/useEspaceFormateur';

// ---------------------------------------------------------------------------
// Formats
// ---------------------------------------------------------------------------

/** « 2026-07-28 » → « 28/07/2026 ». */
export function jourLisible(iso: string | null): string {
  if (!iso) return '—';
  const [annee, mois, jour] = iso.slice(0, 10).split('-');
  return `${jour}/${mois}/${annee}`;
}

export function demiJourneeLisible(valeur: string | null): string {
  if (valeur === 'MATIN') return 'matin';
  if (valeur === 'APRES_MIDI') return 'après-midi';
  return '';
}

const NOMBRE = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 });

export function heuresLisibles(valeur: number | null): string {
  return valeur === null ? '—' : `${NOMBRE.format(valeur)} h`;
}

export function horodatage(instant: string | null): string {
  if (!instant) return '—';
  return new Date(instant).toLocaleString('fr-FR', {
    timeZone: 'Indian/Reunion',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Délai restant ou dépassé, tel que l'API le compte. */
export function delaiLisible(ligne: Pick<LigneFiche, 'etat' | 'joursRestants' | 'horsDelai'>): string | null {
  if (ligne.etat === 'VALIDEE' || ligne.joursRestants === null) return null;
  if (ligne.horsDelai) {
    const retard = -ligne.joursRestants;
    return `Hors délai depuis ${retard} jour${retard > 1 ? 's' : ''}`;
  }
  if (ligne.joursRestants === 0) return 'Dernier jour pour la faire valider';
  return `${ligne.joursRestants} jour${ligne.joursRestants > 1 ? 's' : ''} pour la faire valider`;
}
